/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
'use strict';

module.exports = {
    BaseStore: require('./BaseStore'),
    createStore: require('./createStore')
};



//////////////////
// WEBPACK FOOTER
// ./~/fluxible/addons/index.js
// module id = 14
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 15 16 17 20 21